import React from "react";
import { useField } from "formik";

import { ITeam } from "apis";

import { FIELD } from "../../constants";

import { PassPanel } from "./PassPanel";
import { ThroughPassPanel } from "./ThroughPassPanel";
import { PlayerField } from "./PlayerField";
import { ShootPanel } from "./ShootPanel";
import { TacklePanel } from "./TacklePanel";
import { FreeKickPanel } from "./FreeKickPanel";
import { CornerKickPanel } from "./CornerKickPanel";

interface IDetailsPanelProps {
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

export const DetailsPanel = ({ homeTeam, awayTeam }: IDetailsPanelProps) => {
  const [field] = useField(FIELD.action);

  switch (field.value) {
    case "PASS":
      return <PassPanel homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "THROUGH":
      return <ThroughPassPanel homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "DRIBBLE":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "SHOOT":
      return <ShootPanel homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "OFFSIDE":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "TACKLE":
      return <TacklePanel homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "INTERCEPTION":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "BLOCK":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "CLEARANCE":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "SAVING":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "OWN_GOAL":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "FREE_KICK":
      return <FreeKickPanel homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "CORNER_KICK":
      return <CornerKickPanel homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "PENALTY":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "FOUL":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "YELLOW":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    case "RED":
      return <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />;
    default:
      return null;
  }
};
